// Generated types for StakeholderNeed
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { ElicitationMethod } from '../enums';

import { RFLPElementReadAPI, RFLPElementWriteAPI } from './rflpelement';
import { RFLPElementReadAPISchemaObject, RFLPElementWriteAPISchemaObject } from './rflpelement';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface StakeholderNeedReadAPI extends RFLPElementReadAPI {
  /** The captured need statement (paraphrased / cleaned-up form). */
  text: string;
  /** Verbatim stakeholder quote, before any paraphrasing. Preserved separately so the agent / reviewer can always read the original wording. */
  raw_quote?: string | null;
  /** Stakeholder role / named person (e.g. 'Field engineer', 'CEO', 'Regulatory body'). Use `stakeholders` (ToMany User) when the named person is a User in the system. */
  stakeholder_label?: string | null;
  /** How this need was captured. Drives review-time confidence. */
  elicitation_method?: ElicitationMethod;
}

export interface StakeholderNeedWriteAPI extends RFLPElementWriteAPI {
  /** The captured need statement (paraphrased / cleaned-up form). */
  text: string;
  /** Verbatim stakeholder quote, before any paraphrasing. Preserved separately so the agent / reviewer can always read the original wording. */
  raw_quote?: string | null;
  /** Stakeholder role / named person (e.g. 'Field engineer', 'CEO', 'Regulatory body'). Use `stakeholders` (ToMany User) when the named person is a User in the system. */
  stakeholder_label?: string | null;
  /** How this need was captured. Drives review-time confidence. */
  elicitation_method?: ElicitationMethod;
  /** LogicalPart that holds this captured need (the project's root LP for system-level needs). */
  container?: string;
  /** Requirement(s) produced by transforming this need. */
  transformed_to?: string[];
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const StakeholderNeedReadAPISchema: z.ZodType<StakeholderNeedReadAPI> = RFLPElementReadAPISchemaObject.extend({
  text: z.string(),
  raw_quote: z.string().nullable().optional(),
  stakeholder_label: z.string().nullable().optional(),
  elicitation_method: z.nativeEnum(ElicitationMethod).optional(),
}).passthrough();

export const StakeholderNeedWriteAPISchema: z.ZodType<StakeholderNeedWriteAPI> = RFLPElementWriteAPISchemaObject.extend({
  text: z.string(),
  raw_quote: z.string().nullable().optional(),
  stakeholder_label: z.string().nullable().optional(),
  elicitation_method: z.nativeEnum(ElicitationMethod).optional(),
  container: z.string().optional(),
  transformed_to: z.array(z.string()).optional(),
}).passthrough();
